/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Status_Generating_XmlInputs */



/**
* | output |
* | --- |
* | "Generating BDN and FCP XML scripts..." |
*
* @param {Image_Export_Status_Generating_XmlInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_generating_xml = /** @type {((inputs?: Image_Export_Status_Generating_XmlInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Generating_XmlInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generation des scripts XML BDN et FCP...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Generiere BDN- und FCP-XML-Skripte...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione degli script XML BDN e FCP in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Генерация XML-скриптов BDN и FCP...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando scripts XML BDN y FCP...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在生成 BDN 和 FCP XML 脚本...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("BDN XML と FCP XML スクリプトを生成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बीडीएन और एफसीपी एक्सएमएल स्क्रिप्ट तैयार की जा रही हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerando scripts XML BDN e FCP...")
	return /** @type {LocalizedString} */ ("Generating BDN and FCP XML scripts...")
});